import { z } from "zod";

export type OverWaterProtectionSettings = {
    enabled: boolean;
    maxMsWithoutWater?: number;
    maxIrrigationDuration?: number;
    maxIrrigationMsPerWeek?: number;
    minIrrigationMsPerWeek?: number;
};

export const OverWaterProtectionSettingsSchema = z.object({
    enabled: z.boolean(),
    maxMsWithoutWater: z.number().optional(),
    maxIrrigationDuration: z.number().optional(),
    maxIrrigationMsPerWeek: z.number().optional(),
    minIrrigationMsPerWeek: z.number().optional(),
});
